import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Footer } from "../Common/Footer";
import { Header } from "../Common/Header";
import { faComment, faSearch } from "@fortawesome/free-solid-svg-icons";
import "./Blogs.css";
import blog1 from "./blogimages/blog1.webp";
import blog2 from "./blogimages/blog2.webp";
import blog3 from "./blogimages/blog3.webp";
import blog4 from "./blogimages/blog4.webp";
import blog5 from "./blogimages/blog5.webp";
import blog6 from "./blogimages/blog6.webp";
import { faFacebookF, faLinkedinIn, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export function Blogs(){
    return(
        <>
        <Header/>
        <section className="container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col-lg-9 col-12 blog-left p-lg-5 p-2">
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog1} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog2} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog3} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog4} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog5} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        <div className="block mb-3 py-2">
                            <div className="blog-img">
                                <img src={blog6} alt="" className="img-fluid" />
                            </div>
                            <div className="blog-time">
                                <p>uncategorized / August 12, 2023 / <FontAwesomeIcon icon={faComment}/> 0</p>
                            </div>
                            <h2>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</h2>
                            <div className="blogp pcolor py-2">
                                <p>In recent times, Rajasthan real estate has come back into the public eye. The development of wealthy entrepreneurs and new employment prospects are two elements that have contributed to this resurgence of interest. More people are purchasing real estate in Jodhpur as a result of these changes, whether to be near their relatives or for...</p>
                            </div>
                            <div className="blog-icons d-flex align-items-center gap-2">
                                <div className="bicon d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faFacebookF}/>
                                </div>
                                <div className="bicon skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faTwitter}/>
                                </div>
                                <div className="bicon fcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faLinkedinIn}/>
                                </div>
                                <div className="bicon gcolor skycolor d-flex justify-content-center align-items-center">
                                    <FontAwesomeIcon icon={faWhatsapp}/>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-lg-3 col-12 blog-right px-3 py-5">
                        <div className="blog-info">
                                <form>
                                    <input type="text" name="s" placeholder="Looking for..." />
                                    <button type="submit" className="blog-btn">
                                        <FontAwesomeIcon icon={faSearch}/>
                                    </button>
                                </form>
                                <h4 className="rpost fs-24 py-5 fw-700">Recent Posts</h4>
                                <div className="post-content ">
                                    <p>Investing in Rajasthan Real Estate: Top-5 Properties for Sale in Jodhpur</p>
                                </div>
                                <div className="post-content mt-3">
                                    <p>The Real Estate Boom: A Closer Look at Rajasthan Property Price</p>
                                </div>
                                <div className="post-content mt-3">
                                    <p>Real Estate Businesses in Rajasthan</p>
                                </div>
                                <h4 className="rpost fs-24 py-5 fw-700">Recent Comments</h4>
                                <div className="post-content pb-2">
                                    <span className="span1">ashapurna-adminpanel</span>
                                    <span> on </span>
                                    <span className="span2 ">Ashapurna NRI : Now Europe In Jodhpur</span>
                                </div>
                                <div className="post-content pb-2 mt-3">
                                    <span className="span1">ashapurna-adminpanel</span>
                                    <span> on </span>
                                    <span className="span2 ">Ashapurna NRI : Now Europe In Jodhpur</span>
                                </div>
                                <div className="post-content pb-2 mt-3">
                                    <span className="span1">ashapurna-adminpanel</span>
                                    <span> on </span>
                                    <span className="span2 ">Ashapurna NRI : Now Europe In Jodhpur</span>
                                </div>
                                <div className="post-content pb-2 mt-3">
                                    <span className="span1">ashapurna-adminpanel</span>
                                    <span> on </span>
                                    <span className="span2 ">Ashapurna NRI : Now Europe In Jodhpur</span>
                                </div>
                                <div className="post-content pb-2 mt-3">
                                    <span className="span1">ashapurna-adminpanel</span>
                                    <span> on </span>
                                    <span className="span2 ">Ashapurna NRI : Now Europe In Jodhpur</span>
                                </div>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </section>
        <Footer/>
        </>
    )
}